"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.findCategoryDeep = findCategoryDeep;
function findCategoryDeep(tree, id) {
    var result = null;
    if (!Array.isArray(tree)) {
        return result;
    }
    for (var idx in tree) {
        result = tree[idx] != null && tree[idx].id == id ? tree[idx] : tree[idx] == null ? null : findCategoryDeep(tree[idx].children, id);
        if (result !== null) {
            return result;
        }
    }

    return result;
}

var addMinValueToOffer = exports.addMinValueToOffer = function addMinValueToOffer(offer) {
    // if (offer.childOffer && offer.childOffer.nestedOffers && offer.childOffer.nestedOffers.length) {
    //     offer.childOffer.nestedOffers = offer.childOffer.nestedOffers.map(item => addMinValueToOffer(item))
    // }
    return offer;
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/catalog/utils.js
// module id = 386
// module chunks = 0